import { STATE_TO_IANA_TZ } from '@bonsai/shared';

/**
 * State/DC code to full name, for labelling the client-site State select.
 * The select itself is driven by `STATE_TO_IANA_TZ`'s own keys (the states
 * the backend can actually resolve a timezone for) — this map only supplies
 * a display name for whichever codes that set contains.
 */
const STATE_NAMES: Record<string, string> = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export interface StateOption {
  code: string;
  name: string;
}

/** Every state (2-letter code, kept as the select's value) a client-site
 *  event can resolve a timezone for, labelled with its full name and sorted
 *  alphabetically by that name. */
export const CLIENT_SITE_STATE_OPTIONS: StateOption[] = Object.keys(STATE_TO_IANA_TZ)
  .map((code) => ({ code, name: STATE_NAMES[code] ?? code }))
  .sort((a, b) => a.name.localeCompare(b.name));
